<script>
    export default {
        name: 'text-field',
        props: {
            rules: {
            },
            value: {
            },
            label: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            type: {
                type: String
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            placeholder: {

            },
            error: {

            },
            clearable: Boolean,
            textarea: Boolean,
            autoGrow: Boolean,
            errorMessage: String,
            noResize: Boolean,
            appendIcon: String,
            autocomplete: String,
            role: String,
            hideDetails: String
        },
        data() {
            return {
                hasNotBeenTouchedYet: true
            }
        },
        methods: {
            handleEmit(event) {
                // console.log('Emit')
                this.hasNotBeenTouchedYet = false;
                this.$emit('input', event);
            }
        },
        computed: {
            showError() {
                if (this.hasNotBeenTouchedYet) return false;
                return this.error;
            },
            showErrorMessage() {
                if (this.hasNotBeenTouchedYet) return null;
                return this.errorMessage;
            }
        },
        mounted() {
            this.hasNotBeenTouchedYet = true;
        }
    }
</script>

<template>
    <v-text-field v-if="!textarea"
        v-bind="$attrs"
        validate-on-blur
        :autocomplete="autocomplete"
        :role ="role"
        class="w-100"
        :rules="rules"
        :label="label"
        :value="value"
        :type="type"
        @input="handleEmit"
        @click:append="$emit('click:append', $event)"
        :disabled="disabled"
        :clearable="clearable"
        outlined
        dense
        :autofocus="autofocus"
        :placeholder="placeholder"
        :errorMessages="showErrorMessage"
        :appendIcon="appendIcon"
        :hideDetails="hideDetails"
    />
    <v-textarea v-else
        v-bind="$attrs"
        validate-on-blur
        class="w-100"
        :rules="rules"
        :label="label"
        :value="value"
        :type="type"
        @input="handleEmit"
        :disabled="disabled"
        outlined
        dense
        :autofocus="autofocus"
        :placeholder="placeholder"
        :autoGrow="autoGrow"
        :noResize="noResize"
    />
</template>

<style>
    .w-100 {
        width: 100%;
    }
    .v-text-field__slot  label {
        font-weight: 400;
        width: unset;
    }
</style>
